import {
  Component,
  ElementRef,
  Input,
  OnInit,
  Renderer2,
  SimpleChanges,
} from "@angular/core";
import { TokenStorageService } from "src/app/core/auth/token-storage.service";

@Component({
  selector: "app-push-notification-view",
  templateUrl: "./push-notification-view.component.html",
  styleUrls: ["./push-notification-view.component.css"],
})
export class PushNotificationViewComponent implements OnInit {
  constructor(
    private renderer: Renderer2,
    private tokeStorage: TokenStorageService,
    private el: ElementRef
  ) {}

  isCollapsed: boolean = false;
  storeName = this.tokeStorage.getShopName();
  typeOfView = [
    {
      displayName: "Google Andriod",
      type: "ANDRIOD",
    },
    {
      displayName: "iOS",
      type: "IOS",
    },
  ];
  viewType = "ANDRIOD";
  @Input() header: string;
  @Input() body: string;
  @Input() uploadedImg: string;

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["header"]) {
      if (!this.isCollapsed && this.viewType === "ANDRIOD")
        this.updateElements();
    }

    if (changes["body"]) {
      if (!this.isCollapsed && this.viewType === "ANDRIOD")
        this.updateElements();
    }

    if (changes["uploadedImg"]) {
      if (!this.isCollapsed && this.viewType === "ANDRIOD")
        this.updateElements();
    }
  }

  ngAfterViewInit() {
    this.updateElements();
  }

  addElements() {
    // Get the container div
    const container = document.getElementById("pn-div");

    if (container) {
      // Create and append the h1
      const newH1 = this.renderer.createElement("h1");
      this.renderer.setAttribute(newH1, "id", "uniqueH1");
      this.renderer.addClass(newH1, "qb-header-message-expand"); // Add class to h1
      const text = this.renderer.createText(this.header);
      this.renderer.appendChild(newH1, text);
      this.renderer.appendChild(container, newH1);

      // Create and append the div
      const newDiv = this.renderer.createElement("div");
      this.renderer.setAttribute(newDiv, "id", "uniqueDiv");
      this.renderer.addClass(newDiv, "qb-message-area"); // Add class to div
      const body = this.renderer.createText(this.body);
      this.renderer.appendChild(newDiv, body);
      this.renderer.appendChild(container, newDiv);

      // Create and append the img
      const newImg = this.renderer.createElement("img");
      this.renderer.setAttribute(newImg, "id", "uniqueImg");
      this.renderer.addClass(newImg, "qb-img-area"); // Add class to img
      this.renderer.setAttribute(newImg, "src", this.uploadedImg);
      this.renderer.appendChild(container, newImg);
    }
  }

  updateElements() {
    const container = this.el.nativeElement.querySelector("#pn-div");

    if (container) {
      // Update h1 element
      let h1Element = container.querySelector("#uniqueH1");
      if (!h1Element) {
        h1Element = this.renderer.createElement("h1");
        this.renderer.setAttribute(h1Element, "id", "uniqueH1");
        this.renderer.addClass(h1Element, "qb-header-message-expand");
        this.renderer.appendChild(container, h1Element);
      }
      h1Element.textContent = this.header; // Update text content

      // Update div element
      let divElement = container.querySelector("#uniqueDiv");
      if (!divElement) {
        divElement = this.renderer.createElement("div");
        this.renderer.setAttribute(divElement, "id", "uniqueDiv");
        this.renderer.addClass(divElement, "qb-message-area");
        this.renderer.appendChild(container, divElement);
      }
      divElement.textContent = this.body; // Update text content

      // Update img element
      let imgElement = container.querySelector("#uniqueImg");
      if (!imgElement) {
        imgElement = this.renderer.createElement("img");
        this.renderer.setAttribute(imgElement, "id", "uniqueImg");
        this.renderer.addClass(imgElement, "qb-img-area");
        this.renderer.appendChild(container, imgElement);
      }
      this.renderer.setAttribute(imgElement, "src", this.uploadedImg || ""); // Update image source
    }
  }

  // Function to remove elements by their ids
  removeElements() {
    const div = document.getElementById("uniqueDiv");
    const h1 = document.getElementById("uniqueH1");
    const img = document.getElementById("uniqueImg");

    if (div) div.remove();
    if (h1) h1.remove();
    if (img) img.remove();
  }

  expandView() {
    if (this.viewType === "ANDRIOD") {
      const element1 = document.getElementById("pn-div");
      const element2 = document.getElementById("andriod-header-container");
      if (element1) {
        element1.className = !this.isCollapsed
          ? "qb-notification-div-andriod-collapse"
          : "qb-notification-div-andriod-expand";
      }
      if (element2) {
        element2.className = !this.isCollapsed
          ? "qb-header-container-collapse"
          : "qb-header-container";
      }
      if (this.isCollapsed) {
        this.updateElements();
      } else {
        this.removeElements();
      }
    } else {
      this.expnadIosView();
    }
    this.isCollapsed = !this.isCollapsed;
  }

  expnadIosView() {
    const element = document.getElementById("pn-wrapper-ios");
    if (element) {
      element.className =
        this.isCollapsed && this.uploadedImg
          ? "qb-notification-wrapper-apple-img-present"
          : "qb-notification-wrapper-apple";
    }
  }

  onViewTypeChange(event) {
    this.isCollapsed = false;
    if (event.value === "ANDRIOD") {
      setTimeout(() => {
        this.updateElements();
      }, 100);
    } else {
      this.expnadIosView();
    }
  }
}
